import * as TK from 'components/comments/Comments/translations/constants';
import { Translations } from 'translations/types';

export const commentsEnUsLocale: Translations = {
  [TK.COMMENTS_NO_COMMENTS]: 'No comments yet.',
};
